






























import { Component, Vue } from 'vue-property-decorator'
import { Action } from 'vuex-class'

import { LoginForm } from '@/components'

import { FullPage } from '@/layouts/components'

import { AsyncState, Credentials } from '@/models'

@Component({
  components: {
    FullPage,
    LoginForm
  }
})
export default class Login extends Vue {
  loginState = new AsyncState()

  @Action
  login!: (credentials: Credentials) => Promise<void>

  handleRegister () {
    alert('em breve')
  }

  async handleSubmit (credentials: Credentials) {
    try {
      await this.loginState.handle(
        this.login(credentials)
      )

      this.$router.replace('/')
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }
}
